import { FC, useEffect, useMemo, useState } from "react";
import { PaginateModel } from "../../../models/PaginateModel";
import { PaginationLength } from "../../../../_metronic/partials/pagination/PaginationLength";
import { Paginate } from "../../../../_metronic/partials/pagination/Paginate";
import { DEFAULT_PER_PAGE } from "../../../constants/common";
import ConfigModal from "../../../components/Modal/ConfigModal";
import { HeaderModel, ModalModel } from "../../../models/CommonModel";
import ExpensesAccountTable from "../components/ExpensesAccountTable";
import { ExpenseRowModel, ExpenseRowSearchModel } from "../../../models/account-books/ExpensesAccount";
import { download, Toast } from "../../../modules/common/helper";
import { exportExpensesBooks, getExpensesBooks } from "../AccountBooksCRUD";

interface Props {
    opening?: string
    closing?: string
    changeTab: (tab: string) => void
    isFullYear: boolean
}

const ExpensesAccount: FC<Props> = ({opening, closing, changeTab, isFullYear}) => {
    
    const initSearch = useMemo(() => ({
        page: 1,
        per_page: DEFAULT_PER_PAGE,
        start_date: opening,
        end_date: closing
    }), [opening, closing])

    const [search, setSearch] = useState<ExpenseRowSearchModel>(initSearch)
    const [data, setData] = useState<PaginateModel<ExpenseRowModel>>()
    const [subTotal, setSubTotal] = useState<number>(0)
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const [hideCols, setHideCols] = useState<string[]>([]);
    const header: HeaderModel[] = [
        {
            label: 'Ngày ghi sổ',
            field: 'posting_date',
            style: { maxWidth: "90px", minWidth: "90px", },
            sortable: true
        },
        {
            label: 'Số phiếu',
            field: 'doc_no',
            style: { maxWidth: "90px", minWidth: "90px", },
            sortable: true
        },
        {
            label: 'Phân loại',
            field: 'expense_group',
            style: { maxWidth: "150px", minWidth: "150px", },
            sortable: true
        },
        {
            label: 'Phương thức',
            field: 'method',
            style: { maxWidth: "90px", minWidth: "90px", },
            sortable: true
        },
        {
            label: 'Số tiền',
            field: 'amount',
            style: { maxWidth: "150px", minWidth: "150px", textAlign: "center" },
            sortable: true
        },
        {
            label: 'Diễn giải',
            field: 'description',
            style: { maxWidth: "150px", minWidth: "150px", },
            sortable: false
        }
    ]

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    useEffect(() => {
        if (opening && closing) {
            getData({...initSearch});
        }
    }, [opening, closing, initSearch])

    const getData = async (searchParams: ExpenseRowSearchModel) => {
        try {
            const { data: resData } = await getExpensesBooks(searchParams);
            setData(resData.paginate_data);
            setSubTotal(resData.sub_total);
            setSearch(searchParams)
        } catch (e: any) {
            Toast.fire({
                icon: 'error',
                title: 'Đã có lỗi xảy ra, vui lòng thử lại sau!'
            })
        }
    }
    const handleSearch = () => {

    }

    const handlePageLengthChange = (e: any) => {
        getData({ ...search, page: 1, per_page: +e.target.value })
    }

    const handlePageChange = (data: any) => {
        getData({ ...search, page: data.selected + 1 })
    }

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: ExpenseRowSearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getData({ ...sortParams });
    }

    const handleExport = async () => {
        const { data } = await exportExpensesBooks({ ...search });
        download(data, '7-So chi phi SXKD');
    }

    return <>
    <div className='card mt-3'>
      <div className="card-header card-header-stretch">
        <h3 className="card-title">
            <button type="button" className="btn btn-primary btn-sm mx-1 mb-1 me-2" onClick={() => changeTab('index')}>
                <i className="fas fa-angle-left"/> 
            </button>
            Sổ chi phí
        </h3>
        <div className="card-toolbar align-items-center">
            <div className="btn-groups">
                {!isFullYear && (
                    <button className="btn ms-auto btn-sm btn-primary text-hover-white" type="button"
                        onClick={handleExport}>
                        Tải xuống
                    </button>
                )}
            </div>
        </div>
      </div>
      <div className='card-body'>
        <ExpensesAccountTable
          data={data?.data || []}
          openColConfig={() => setConfigModal({ ...configModal, show: true })}
          header={header}
          hideCols={hideCols}
          handleSort={handleSort}
        />
      </div>
      <div className='card-footer d-flex justify-content-between paginate-wrapper'>
        <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
        <Paginate
            pageCount={data?.meta?.last_page || 0}
            onPageChange={handlePageChange}
            forcePage={(search.page || 1) - 1}
        />
      </div>
      <ConfigModal
        {...configModal}
        header={header}
        hideCols={hideCols}
        handleChangeVisCols={handleChangeVisCols}
        onClose={() => { setConfigModal({ ...configModal, show: false }) }}
      />
    </div>
  </>
}

export default ExpensesAccount;